import { BusinessUnitKeyType, ProductBadgeType } from '../../api/models/api-shared.enums';

export class ProductBadgeLookup {
  public static ProductBadgeLookup: { [key in BusinessUnitKeyType]: ProductBadgeReference[] } = {
    [BusinessUnitKeyType.PerformanceFoodService]: [
      { BadgeType: ProductBadgeType.EarlyCutoff, BadgeIcon: 'fa-alarm-clock', isCutOff: true },
      { BadgeType: ProductBadgeType.CriticalItem, BadgeIcon: 'fa-star' },
      { BadgeType: ProductBadgeType.IsHidden, BadgeIcon: 'fa-eye-slash' },
      { BadgeType: ProductBadgeType.IsRetained, BadgeIcon: 'fa-thumbtack' },
      //{ BadgeType: ProductBadgeType.OnManagedList, BadgeIcon: 'fa-list-alt' },
      { BadgeType: ProductBadgeType.MSDS, BadgeIcon: 'fa-flask' },
      { BadgeType: ProductBadgeType.SpecialOrder, BadgeIcon: 'fa-phone' },
      { BadgeType: ProductBadgeType.DirectShip, BadgeIcon: 'fa-box-open' },
      { BadgeType: ProductBadgeType.VirtualWarehouse, BadgeIcon: 'fa-box-open' },
      { BadgeType: ProductBadgeType.IsTemporarilyOut, BadgeIcon: 'fa-ban' },
      { BadgeType: ProductBadgeType.USDAProduct, BadgeIcon: 'fa-solid fa-farm' },
      //{ BadgeType: ProductBadgeType.HasSubstituteProducts, BadgeIcon: 'fa-exchange' },
      { BadgeType: ProductBadgeType.Domestic, BadgeIcon: 'fa-solid fa-flag-usa' },
      { BadgeType: ProductBadgeType.SnackItem, BadgeIcon: 'fa-solid fa-cookie-bite' },
      { BadgeType: ProductBadgeType.ChildNutrition, BadgeIcon: 'fa-solid fa-child' },
    ],
    [BusinessUnitKeyType.Vistar]: [
      { BadgeType: ProductBadgeType.EarlyCutoff, BadgeIcon: 'fa-alarm-clock', isCutOff: true },
      { BadgeType: ProductBadgeType.CriticalItem, BadgeIcon: 'fa-star' },
      { BadgeType: ProductBadgeType.IsHidden, BadgeIcon: 'fa-eye-slash' },
      { BadgeType: ProductBadgeType.IsRetained, BadgeIcon: 'fa-thumbtack' },
      //{ BadgeType: ProductBadgeType.OnManagedList, BadgeIcon: 'fa-list-alt' },
      { BadgeType: ProductBadgeType.MSDS, BadgeIcon: 'fa-flask' },
      { BadgeType: ProductBadgeType.SpecialOrder, BadgeIcon: 'fa-phone' },
      { BadgeType: ProductBadgeType.IsTemporarilyOut, BadgeIcon: 'fa-ban' },
      { BadgeType: ProductBadgeType.USDAProduct, BadgeIcon: 'fa-solid fa-farm' },
      { BadgeType: ProductBadgeType.ShipsLater, BadgeIcon: 'fa-hourglass-half' },
      //{ BadgeType: ProductBadgeType.HasSubstituteProducts, BadgeIcon: 'fa-exchange' },
      { BadgeType: ProductBadgeType.Domestic, BadgeIcon: 'fa-solid fa-flag-usa' },
      { BadgeType: ProductBadgeType.SnackItem, BadgeIcon: 'fa-solid fa-cookie-bite' },
      { BadgeType: ProductBadgeType.ChildNutrition, BadgeIcon: 'fa-solid fa-child' },
    ],
    [BusinessUnitKeyType.PerformanceFoodGroupCustomized]: [
      { BadgeType: ProductBadgeType.EarlyCutoff, BadgeIcon: 'fa-alarm-clock', isCutOff: true },
      { BadgeType: ProductBadgeType.CriticalItem, BadgeIcon: 'fa-star' },
      { BadgeType: ProductBadgeType.IsHidden, BadgeIcon: 'fa-eye-slash' },
      { BadgeType: ProductBadgeType.IsRetained, BadgeIcon: 'fa-thumbtack' },
      //{ BadgeType: ProductBadgeType.OnManagedList, BadgeIcon: 'fa-list-alt' },
      { BadgeType: ProductBadgeType.MSDS, BadgeIcon: 'fa-flask' },
      { BadgeType: ProductBadgeType.IsTemporarilyOut, BadgeIcon: 'fa-ban' },
      { BadgeType: ProductBadgeType.USDAProduct, BadgeIcon: 'fa-solid fa-farm' },
      //{ BadgeType: ProductBadgeType.HasSubstituteProducts, BadgeIcon: 'fa-exchange' },
      { BadgeType: ProductBadgeType.Domestic, BadgeIcon: 'fa-solid fa-flag-usa' },
      { BadgeType: ProductBadgeType.SnackItem, BadgeIcon: 'fa-solid fa-cookie-bite' },
      { BadgeType: ProductBadgeType.ChildNutrition, BadgeIcon: 'fa-solid fa-child' },
    ],
    [BusinessUnitKeyType.ReinhartFoodService]: [
      { BadgeType: ProductBadgeType.EarlyCutoff, BadgeIcon: 'fa-alarm-clock', isCutOff: true },
      { BadgeType: ProductBadgeType.CriticalItem, BadgeIcon: 'fa-star' },
      { BadgeType: ProductBadgeType.IsHidden, BadgeIcon: 'fa-eye-slash' },
      { BadgeType: ProductBadgeType.IsRetained, BadgeIcon: 'fa-thumbtack' },
      //{ BadgeType: ProductBadgeType.OnManagedList, BadgeIcon: 'fa-list-alt' },
      { BadgeType: ProductBadgeType.MSDS, BadgeIcon: 'fa-flask' },
      { BadgeType: ProductBadgeType.SpecialOrder, BadgeIcon: 'fa-phone' },
     // { BadgeType: ProductBadgeType.ShipsLater, BadgeIcon: 'fa-hourglass-half' },
      { BadgeType: ProductBadgeType.DirectShip, BadgeIcon: 'fa-box-open' },
      { BadgeType: ProductBadgeType.IsTemporarilyOut, BadgeIcon: 'fa-ban' },
      { BadgeType: ProductBadgeType.USDAProduct, BadgeIcon: 'fa-solid fa-farm' },
      //{ BadgeType: ProductBadgeType.HasSubstituteProducts, BadgeIcon: 'fa-exchange' },
      { BadgeType: ProductBadgeType.Domestic, BadgeIcon: 'fa-solid fa-flag-usa' },
      { BadgeType: ProductBadgeType.SnackItem, BadgeIcon: 'fa-solid fa-cookie-bite' },
      { BadgeType: ProductBadgeType.ChildNutrition, BadgeIcon: 'fa-solid fa-child' },
      { BadgeType: ProductBadgeType.PortalShipsLater, BadgeIcon: 'fa-hourglass-half' },

    ],
    [BusinessUnitKeyType.Afflink]: [
      { BadgeType: ProductBadgeType.EarlyCutoff, BadgeIcon: 'fa-alarm-clock', isCutOff: true },
      { BadgeType: ProductBadgeType.CriticalItem, BadgeIcon: 'fa-star' },
      { BadgeType: ProductBadgeType.IsHidden, BadgeIcon: 'fa-eye-slash' },
      { BadgeType: ProductBadgeType.IsRetained, BadgeIcon: 'fa-thumbtack' },
      // { BadgeType: ProductBadgeType.OnManagedList, BadgeIcon: 'fa-list-alt' },
      { BadgeType: ProductBadgeType.MSDS, BadgeIcon: 'fa-flask' },
      { BadgeType: ProductBadgeType.IsTemporarilyOut, BadgeIcon: 'fa-ban' },
      { BadgeType: ProductBadgeType.USDAProduct, BadgeIcon: 'fa-solid fa-farm' },
      //{ BadgeType: ProductBadgeType.HasSubstituteProducts, BadgeIcon: 'fa-exchange' },
      { BadgeType: ProductBadgeType.Domestic, BadgeIcon: 'fa-solid fa-flag-usa' },
      { BadgeType: ProductBadgeType.SnackItem, BadgeIcon: 'fa-solid fa-cookie-bite' },
      { BadgeType: ProductBadgeType.ChildNutrition, BadgeIcon: 'fa-solid fa-child' },
    ],
    [BusinessUnitKeyType.EbyBrown]: [
      { BadgeType: ProductBadgeType.EarlyCutoff, BadgeIcon: 'fa-alarm-clock', isCutOff: true },
      { BadgeType: ProductBadgeType.CriticalItem, BadgeIcon: 'fa-star' },
      { BadgeType: ProductBadgeType.IsHidden, BadgeIcon: 'fa-eye-slash' },
      { BadgeType: ProductBadgeType.IsRetained, BadgeIcon: 'fa-thumbtack' },
      //{ BadgeType: ProductBadgeType.OnManagedList, BadgeIcon: 'fa-list-alt' },
      { BadgeType: ProductBadgeType.MSDS, BadgeIcon: 'fa-flask' },
      { BadgeType: ProductBadgeType.IsTemporarilyOut, BadgeIcon: 'fa-ban' },
      { BadgeType: ProductBadgeType.USDAProduct, BadgeIcon: 'fa-solid fa-farm' },
      //{ BadgeType: ProductBadgeType.HasSubstituteProducts, BadgeIcon: 'fa-exchange' },
      { BadgeType: ProductBadgeType.Domestic, BadgeIcon: 'fa-solid fa-flag-usa' },
      { BadgeType: ProductBadgeType.SnackItem, BadgeIcon: 'fa-solid fa-cookie-bite' },
      { BadgeType: ProductBadgeType.ChildNutrition, BadgeIcon: 'fa-solid fa-child' },
    ],
  };
}
export interface ProductBadgeReference {
  BadgeType: ProductBadgeType;
  BadgeIcon: string;
  isCutOff?: boolean;
  customTitle?: string;
}
